import { gql } from "@apollo/client";

export const updateTierRules = gql`
  mutation UpdateTierRules($input: TierRulesInput!) {
    updateTierRules(input: $input) {
      ... on TierRules {
        id
        programId
        qualificationMetric
        evaluationWindowType
        rollingWindowMonths
        immediateDowngradeEnabled
        historicalQualificationMode
        historicalQualificationMonths
        currencyCode
        currencyExponent
        status
        configVersion
        calculationVersion
        excludedSkus
        excludedProductGroups
        metricLocked
        createdAt
        createdBy
        updatedAt
        updatedBy
        reviewDateSchedule {
          type
          date
        }
        productGroupExceptionSkus {
          productGroupId
          skuIds
        }
        activationReadiness {
          ready
          problems {
            field
            errorCode
            message
          }
        }
      }
      ... on MetricChangeBlocked {
        errorCode
        message
        assignedMemberCount
      }
    }
  }
`;
